import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Image3 from '../../../components/images/Image3';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import { Trans } from 'react-i18next';
import  { FULL_MENU } from '../../../api/config/Constants'

export default function() {
  const navigate = useNavigate();

  const handleCatalog = () => {
    navigate(`/web/catalog`, { replace: true })
  }

  return (
    <Box className='search-vehicles-image-card' sx={{margin: '18px 0'}}>
      <Image3/>
      <Box className='search-vehicles-card' style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
        <Box>
          <Box className='search-vehicles-subtitle'><Trans i18nKey={`screens.searchVehicles.sections.rentNewUnit.downloadDocumentation`}/></Box>
          <Box className='search-vehicles-text'><Trans i18nKey={`screens.searchVehicles.sections.rentNewUnit.requireMaintenance`}/></Box>
        </Box>
        {FULL_MENU =='true' && (
        <IconButton onClick={handleCatalog} className='search-vehicles-icon-button'>
          <AddIcon />
        </IconButton>
        )}
      </Box>
    </Box>
  );
}